import { render, staticRenderFns } from "./gongzi.vue?vue&type=template&id=0286190e&scoped=true"
import script from "./gongzi.vue?vue&type=script&lang=js"
export * from "./gongzi.vue?vue&type=script&lang=js"
import style0 from "./gongzi.vue?vue&type=style&index=0&id=0286190e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0286190e",
  null
  
)

export default component.exports